import { FullContainerLoader } from "#/ui/Layout"

import OnboardingModalContent from "./OnboardingModalContent"

type OnboardingModalLoadingScreenProps = {
  label: string
}

export default function OnboardingModalLoadingScreen({
  label,
}: OnboardingModalLoadingScreenProps) {
  return (
    <OnboardingModalContent>
      <FullContainerLoader label={label} />
    </OnboardingModalContent>
  )
}
